import { PageViewType } from '@utils/gtm-tracking/events/trackPageViewEvent';

export const mapToPageType = (alias?: string): PageViewType =>
    (!alias || alias === '' || alias === 'rootPage' ? 'frontPage' : alias) as PageViewType;
